import { Component } from '@angular/core';

@Component({
    selector: 'naker-auth-silent',
    template: 'Processing silent auth...',
})
export class AuthSilentPage {
}
